import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {initializeTranslation} from './i18';
import { initReactI18next } from 'react-i18next';
import { setUserProfile } from "./module/auth/auth.action";
import { setLanguage } from "./module/config/config.action";
import { CONFIG } from "./config/constant";

const InitialComponent = (props) => {
  const dispatch = useDispatch();
  const { token } = useSelector(
    (state) => state.auth
  );
  useEffect(() => {
    getDictionary();
  }, []);


  useEffect(() => {
    let lang= 'en';
    if (!localStorage.getItem('language')) {
      localStorage.setItem('language', lang);
    }else{
      lang = localStorage.getItem('language')
    }
    if (token) {
      getUserProfile();
      dispatch(setLanguage(lang));
    }
  }, [token]);

  

  async function getDictionary() {
    const url = CONFIG.BASE_URL + "app/translation";
    let response = await fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (response && response.status === 200) {
      response = await response.json();
      initializeTranslation(response);
    }
  }

  async function getUserProfile() {
    const url = CONFIG.BASE_URL + "app/account";
    let response = await fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      headers: {
        "Content-Type": "application/json",
        "Authorization": token
      },
    });
    if (response && response.status === 200) {
      response = await response.json();
      dispatch(setUserProfile(response))
    }
  }

  return <></>;
};

export default InitialComponent;
